/**
 * Shared enum definitions that mirror Prisma schema enums.
 * Safe to import in client-side code (no Prisma runtime dependency).
 *
 * IMPORTANT: Keep these in sync with prisma/schema.prisma
 */

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const WorkspaceInvitationStatus = {
	ACCEPTED: "ACCEPTED",
	EXPIRED: "EXPIRED",
	FAILED: "FAILED",
	PENDING: "PENDING",
} as const;
export type WorkspaceInvitationStatus =
	(typeof WorkspaceInvitationStatus)[keyof typeof WorkspaceInvitationStatus];

export const UserRole = {
	ADMIN: "ADMIN",
	USER: "USER",
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const SchedulerSourceType = {
	MANUAL: "MANUAL",
	SCHEDULED: "SCHEDULED",
	WEBHOOK: "WEBHOOK",
} as const;
export type SchedulerSourceType =
	(typeof SchedulerSourceType)[keyof typeof SchedulerSourceType];

export const SchedulerJobStatus = {
	CANCELLED: "CANCELLED",
	COMPLETED: "COMPLETED",
	FAILED: "FAILED",
	PENDING: "PENDING",
	RUNNING: "RUNNING",
} as const;
export type SchedulerJobStatus =
	(typeof SchedulerJobStatus)[keyof typeof SchedulerJobStatus];

export const ExecutionStatus = {
	CANCELLED: "CANCELLED",
	COMPLETED: "COMPLETED",
	FAILED: "FAILED",
	PENDING: "PENDING",
	RUNNING: "RUNNING",
} as const;
export type ExecutionStatus =
	(typeof ExecutionStatus)[keyof typeof ExecutionStatus];

export const AgentType = {
	AUTOMATION_ORCHESTRATOR: "AUTOMATION_ORCHESTRATOR",
	HYBRID_ORCHESTRATOR: "HYBRID_ORCHESTRATOR",
	LLM_ANALYTICS: "LLM_ANALYTICS",
} as const;
export type AgentType = (typeof AgentType)[keyof typeof AgentType];

export const AgentMemoryType = {
	INSIGHT: "INSIGHT",
	ORCHESTRATION_SNAPSHOT: "ORCHESTRATION_SNAPSHOT",
	PATTERN: "PATTERN",
	RUN_SUMMARY: "RUN_SUMMARY",
	USER_FEEDBACK: "USER_FEEDBACK",
} as const;
export type AgentMemoryType =
	(typeof AgentMemoryType)[keyof typeof AgentMemoryType];

export const HybridWorkItemStatus = {
	CANCELLED: "CANCELLED",
	FAILED: "FAILED",
	PENDING: "PENDING",
	RUNNING: "RUNNING",
	SUCCEEDED: "SUCCEEDED",
	UNASSIGNED: "UNASSIGNED",
} as const;
export type HybridWorkItemStatus =
	(typeof HybridWorkItemStatus)[keyof typeof HybridWorkItemStatus];

export const OrganizationAutomationInboxStatus = {
	ACTIVE: "ACTIVE",
	DISABLED: "DISABLED",
	PENDING_PROVISION: "PENDING_PROVISION",
} as const;
export type OrganizationAutomationInboxStatus =
	(typeof OrganizationAutomationInboxStatus)[keyof typeof OrganizationAutomationInboxStatus];

export const AutomationMailboxWatchStatus = {
	ACTIVE: "ACTIVE",
	FAILED: "FAILED",
	PENDING: "PENDING",
} as const;
export type AutomationMailboxWatchStatus =
	(typeof AutomationMailboxWatchStatus)[keyof typeof AutomationMailboxWatchStatus];

export const InboxIntakeStatus = {
	AMBIGUOUS: "AMBIGUOUS",
	FAILED: "FAILED",
	IGNORED: "IGNORED",
	PROCESSED: "PROCESSED",
} as const;
export type InboxIntakeStatus =
	(typeof InboxIntakeStatus)[keyof typeof InboxIntakeStatus];

/** Sentinel Skill Profile id for classic non-profiled AgentSkills. */
export const DEFAULT_SKILL_PROFILE_ID = "default" as const;

/** Sentinel instance key for single-instance AgentSkills (Bill Splitter, AP agents). */
export const DEFAULT_SKILL_INSTANCE_KEY = "primary" as const;

export const NotificationPreference = {
	EMAIL: "EMAIL",
	IN_APP: "IN_APP",
	NONE: "NONE",
} as const;
export type NotificationPreference =
	(typeof NotificationPreference)[keyof typeof NotificationPreference];

export const Status = {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE",
	PENDING: "PENDING",
	SUSPENDED: "SUSPENDED",
} as const;
export type Status = (typeof Status)[keyof typeof Status];

export const ViewStatus = {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE",
} as const;
export type ViewStatus = (typeof ViewStatus)[keyof typeof ViewStatus];

export const ProviderType = {
	APP_FOOLIO: "APP_FOOLIO",
	APPFOLIO_DATABASE: "APPFOLIO_DATABASE",
	ASANA: "ASANA",
	CALL_LINKS: "CALL_LINKS",
	GADMIN: "GADMIN",
	GMELIUS: "GMELIUS",
	GOTO_CONNECT: "GOTO_CONNECT",
	OPINIION: "OPINIION",
	PODIUM: "PODIUM",
	QUICKBOOKS: "QUICKBOOKS",
	RENTENGINE: "RENTENGINE",
	RENTVINE: "RENTVINE",
	SHOWMOJO: "SHOWMOJO",
	YARDI: "YARDI",
	ZOOM: "ZOOM",
} as const;
export type ProviderType = (typeof ProviderType)[keyof typeof ProviderType];

export const WorkflowTriggerType = {
	API: "API",
	DATA_CHANGE: "DATA_CHANGE",
	MANUAL: "MANUAL",
	SCHEDULED: "SCHEDULED",
	USER_ACTION: "USER_ACTION",
} as const;
export type WorkflowTriggerType =
	(typeof WorkflowTriggerType)[keyof typeof WorkflowTriggerType];

export const WorkflowStatus = {
	ACTIVE: "ACTIVE",
	DRAFT: "DRAFT",
	INACTIVE: "INACTIVE",
} as const;
export type WorkflowStatus =
	(typeof WorkflowStatus)[keyof typeof WorkflowStatus];

export const AlertStatus = {
	ACTIVE: "ACTIVE",
	COMPLETED: "COMPLETED",
	DRAFT: "DRAFT",
	INACTIVE: "INACTIVE",
} as const;
export type AlertStatus = (typeof AlertStatus)[keyof typeof AlertStatus];

export const WorkflowStepType = {
	API_CALL: "API_CALL",
	APPROVAL: "APPROVAL",
	CONDITION: "CONDITION",
	CUSTOM: "CUSTOM",
	DATA_SUMMARIZATION: "DATA_SUMMARIZATION",
	DATA_UPDATE: "DATA_UPDATE",
	DELAY: "DELAY",
	NOTIFICATION: "NOTIFICATION",
	TRIGGER_GENERATION: "TRIGGER_GENERATION",
} as const;
export type WorkflowStepType =
	(typeof WorkflowStepType)[keyof typeof WorkflowStepType];

export const NotificationType = {
	EMAIL: "EMAIL",
	IN_APP: "IN_APP",
	PUSH: "PUSH",
	SMS: "SMS",
	WEBHOOK: "WEBHOOK",
} as const;
export type NotificationType =
	(typeof NotificationType)[keyof typeof NotificationType];

export const NotificationStatus = {
	CLOSED: "CLOSED",
	FAILED: "FAILED",
	PENDING: "PENDING",
	READ: "READ",
	SENT: "SENT",
	VIEWED: "VIEWED",
} as const;
export type NotificationStatus =
	(typeof NotificationStatus)[keyof typeof NotificationStatus];

export const VisualizationStatus = {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE",
} as const;
export type VisualizationStatus =
	(typeof VisualizationStatus)[keyof typeof VisualizationStatus];

export const VisualizationType = {
	BAR_CHART: "BAR_CHART",
	BUBBLE_CHART: "BUBBLE_CHART",
	COLUMN_CHART: "COLUMN_CHART",
	COMPOSED_CHART: "COMPOSED_CHART",
	DATA_POINT: "DATA_POINT",
	FUNNEL_CHART: "FUNNEL_CHART",
	GANTT: "GANTT",
	HEAT_MAP: "HEAT_MAP",
	LINE_GRAPH: "LINE_GRAPH",
	MAP: "MAP",
	OTHER: "OTHER",
	PIE_CHART: "PIE_CHART",
	RADAR_CHART: "RADAR_CHART",
	RADIAL_CHART: "RADIAL_CHART",
	SANKEY_CHART: "SANKEY_CHART",
	SCATTER_PLOT: "SCATTER_PLOT",
	TABLE: "TABLE",
} as const;
export type VisualizationType =
	(typeof VisualizationType)[keyof typeof VisualizationType];

export const DataSourceType = {
	API_CALL: "API_CALL",
} as const;
export type DataSourceType =
	(typeof DataSourceType)[keyof typeof DataSourceType];

export const ViewType = {
	CUSTOM: "CUSTOM",
	SYSTEM: "SYSTEM",
} as const;
export type ViewType = (typeof ViewType)[keyof typeof ViewType];

export const GoalPostType = {
	AVERAGE: "AVERAGE",
	TOTAL: "TOTAL",
} as const;
export type GoalPostType = (typeof GoalPostType)[keyof typeof GoalPostType];

export const DataMigrationStatus = {
	FAILED: "FAILED",
	PENDING: "PENDING",
	SUCCESS: "SUCCESS",
} as const;
export type DataMigrationStatus =
	(typeof DataMigrationStatus)[keyof typeof DataMigrationStatus];
